import { render } from "./App.vue?vue&type=template&id=b9d66912"
const script = {}

import "./App.vue?vue&type=style&index=0&id=b9d66912&lang=css"

import exportComponent from "C:\\Users\\jackh\\OneDrive\\桌面\\vite\\點點簽\\f2e_week2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__